import { gql, useMutation } from '@apollo/client';
import { subscriptionsPublicClient } from '../lib/apollo/clients';

export const CREATE_SETUP_INTENT = gql`
  mutation createSetupIntent(
    $name: String!
    $email: Email!
    $phone: String!
    $businessName: String!
    $postalCode: String!
  ) {
    createSetupIntent(
      name: $name
      email: $email
      phone: $phone
      businessName: $businessName
      postalCode: $postalCode
    ) {
      clientSecret
      customer
      id
    }
  }
`;

export const CREATE_PUBLIC_SETUP_INTENT = gql`
  mutation createSetupIntent(
    $firstName: String!
    $lastName: String!
    $email: Email!
    $phone: String!
    $businessName: String
    $postalCode: String!
  ) {
    createSetupIntent(
      firstName: $firstName
      lastName: $lastName
      email: $email
      phone: $phone
      businessName: $businessName
      postalCode: $postalCode
    ) {
      clientSecret
      customer
      id
    }
  }
`;

function useCreateSetupIntent(isPublic) {
  const options = isPublic ? { client: subscriptionsPublicClient } : null;
  const setUp = isPublic ? CREATE_PUBLIC_SETUP_INTENT : CREATE_SETUP_INTENT;
  return useMutation(setUp, options);
}

export default useCreateSetupIntent;
